<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>
        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <!-- Start:: Name Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('MESSAGES.festival provider name')"
                v-model.trim="filterOptions.name"
              />
              <!-- End:: Name Input -->

              <!-- <base-select-input col="4" :optionsList="allMainProviders" :placeholder="$t('PLACEHOLDERS.main_section')"
                v-model="filterOptions.main_section" required /> -->

              <!-- <base-select-input col="4" :optionsList="allSubProviders" :placeholder="$t('PLACEHOLDERS.sub_section')"
                v-model="data.sub_section" required /> -->

              <!-- Start:: Status Input -->
              <base-select-input
                col="6"
                :optionsList="activeStatuses"
                :placeholder="$t('PLACEHOLDERS.status')"
                v-model="filterOptions.status"
              />
              <!-- End:: Status Input -->
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>
              <button
                class="reset_btn"
                type="button"
                :disabled="isWaitingRequest"
                @click="resetFilter"
              >
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("MESSAGES.Festival providers") }}</h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>
        <div class="title_route_wrapper" v-if="$can('festivalproviders create', 'festivalproviders')">
          <button
            style="padding: 5px 20px !important"
            class="btn d-flex align-items-center gap-2"
            :disabled="selected.length !== 2"
            @click="exchangeOrders"
          >
            <span v-if="selected.length === 2">{{ selected[0] }}</span>
            <i class="fa fa-exchange"></i>
            <span v-if="selected.length === 2">{{ selected[1] }}</span>
          </button>
          <router-link to="/festival-providers/create">
            {{ $t("MESSAGES.Add new festival provider") }}
          </router-link>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
        :item-class="getRowClass"
      >
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- Start:: No Data State -->

        <template v-slot:[`item.id`]="{ item, index }">
          <p class="blue-grey--text text--darken-1 fs-3" v-if="!item.id">-</p>
          <p v-else>
            {{
              (paginations.current_page - 1) * paginations.items_per_page +
              index +
              1
            }}
          </p>
        </template>

        <!-- Start:: Sort -->
        <template v-slot:[`item.sort`]="{ item }">
          <span> ({{ item.order_position }}) </span>
          <input
            type="checkbox"
            :value="item.id"
            v-model="selected"
            @change="handleChange"
          />
        </template>
        <!-- End:: Sort -->
        <!-- Start:: Activation -->
        <template v-slot:[`item.is_active`]="{ item }">
          <div
            class="activation"
            dir="ltr"
            style="z-index: 1"
            v-if="$can('festivalproviders activate', 'festivalproviders')"
          >
            <v-switch
              class="mt-2"
              color="success"
              v-model="item.is_active"
              hide-details
              @change="changeActivationStatus(item)"
            ></v-switch>
          </div>

          <template v-else>
            <span class="text-success text-h5" v-if="item.is_active">
              <i class="far fa-check"></i>
            </span>
            <span class="text-danger text-h5" v-else>
              <i class="far fa-times"></i>
            </span>
          </template>
        </template>
        <!-- End:: Activation -->

        <template v-slot:[`item.balance`]="{ item }">
          <span class="ltr_text">
            {{ resolveProviderBalance(item) }}
            {{ $t("PLACEHOLDERS.riyal") }}
          </span>
        </template>

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <a-tooltip placement="bottom" v-if="$can('festivalproviders show', 'festivalproviders')">
              <template slot="title">
                <span>{{ $t("BUTTONS.show") }}</span>
              </template>
              <button class="btn_show" @click="showItem(item)">
                <i class="fal fa-eye"></i>
              </button>
            </a-tooltip>
            

            <a-tooltip placement="bottom" v-if="$can('festivalproviders show', 'festivalproviders')">
              <template slot="title">
                <span>{{ $t("MESSAGES.work_hours") }}</span>
              </template>
              <button class="btn_show" @click="timeItem(item)">
                <i class="fa fa-clock"></i>
              </button>
            </a-tooltip>

            <a-tooltip placement="bottom" v-if="$can('festivalproviders show', 'festivalproviders')">
              <template slot="title">
                <span>{{ $t("MESSAGES.festival provider branches") }}</span>
              </template>
              <button class="btn_show" @click="departItem(item)">
                <i class="fas fa-building"></i>
              </button>
            </a-tooltip>

            <a-tooltip placement="bottom" v-if="$can('festivalproviders edit', 'festivalproviders')">
              <template slot="title">
                <span>{{ $t("MESSAGES.adjustBalance") }}</span>
              </template>
              <button class="btn_show" @click="openAdjustBalanceModal(item)">
                <i class="fas fa-wallet"></i>
              </button>
            </a-tooltip>

            <a-tooltip placement="bottom" v-if="$can('festivalproviders edit', 'festivalproviders')">
              <template slot="title">
                <span>{{ $t("BUTTONS.edit") }}</span>
              </template>
              <button class="btn_edit" @click="editItem(item)">
                <i class="fal fa-edit"></i>
              </button>
            </a-tooltip>

            <a-tooltip placement="bottom" v-if="$can('festivalproviders delete', 'festivalproviders')">
              <template slot="title">
                <span>{{ $t("BUTTONS.delete") }}</span>
              </template>
              <button class="btn_delete" @click="selectDeleteItem(item)">
                <i class="fal fa-trash-alt"></i>
              </button>
            </a-tooltip>

            <template v-else>
              <i
                class="fal fa-lock-alt fs-5 blue-grey--text text--darken-1"
              ></i>
            </template>
          </div>
        </template>
        <!-- End:: Actions -->

        <!-- ======================== Start:: Dialogs ======================== -->
        <template v-slot:top>
          <v-dialog v-model="dialogDelete">
            <v-card>
              <v-card-title class="text-h5 justify-center" v-if="itemToDelete">
                {{
                  $t("TITLES.DeleteConfirmingMessage", {
                    name: itemToDelete.name,
                  })
                }}
              </v-card-title>
              <v-card-actions>
                <v-btn class="modal_confirm_btn" @click="confirmDeleteItem">{{
                    $t("BUTTONS.ok")
                  }}
                </v-btn>

                <v-btn class="modal_cancel_btn" @click="dialogDelete = false">{{
                    $t("BUTTONS.cancel")
                  }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogStats">
            <v-card>
              <v-card-title class="text-h5 justify-center" v-if="itemToStats">
                <div>
                  <h5>{{ $t("MESSAGES.Number of shares of the profile of service provider by the client") }}</h5>
                  <div style="display: flex;align-items: baseline;justify-content: center;" class="mb-2">
                    <div>
                      <button @click="incrementShare" class="btn btn-success"><i class="fa fa-plus-circle"></i></button>
                    </div>
                    <div>
                      <input v-model="shares_count" class="form-control">
                    </div>

                    <div>
                      <button @click="decrementShare" v-bind:disabled="shares_count<1" class="btn btn-danger"><i
                        class="fa fa-minus-circle"></i></button>
                    </div>
                  </div>
                </div>
                <div>
                  <h5>
                    {{ $t("MESSAGES.Number of times the service provider was added to the favorites of customer") }}</h5>
                  <div style="display: flex;align-items: baseline;justify-content: center;" class="mb-2">
                    <div>
                      <button @click="incrementFav" class="btn btn-success"><i class="fa fa-plus-circle"></i></button>
                    </div>
                    <div>
                      <input v-model="favorites_count" class="form-control">
                    </div>

                    <div>
                      <button @click="decrementFav" v-bind:disabled="favorites_count<1" class="btn btn-danger"><i
                        class="fa fa-minus-circle"></i></button>
                    </div>
                  </div>

                </div>
              </v-card-title>
              <v-card-actions>
                <v-btn class="modal_confirm_btn" @click="confirmAddStats">{{
                    $t("MESSAGES.update")
                  }}
                </v-btn>

                <v-btn class="modal_cancel_btn" @click="dialogDelete = false">{{
                    $t("BUTTONS.cancel")
                  }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogAdjustBalance" max-width="520">
            <v-card>
              <v-card-title class="text-h6 justify-center">
                {{ $t("MESSAGES.adjustBalance") }}
              </v-card-title>
              <v-card-text v-if="itemToAdjustBalance">
                <p class="adjust_balance_provider_name">
                  {{ itemToAdjustBalance.name }}
                </p>
                <div class="adjust_balance_field">
                  <label>{{ $t("MESSAGES.centerBalance") }}</label>
                  <p class="adjust_balance_value">
                    {{ centerBalance }}
                    <span>{{ $t("PLACEHOLDERS.riyal") }}</span>
                  </p>
                </div>
                <div class="adjust_balance_field">
                  <label>
                    {{ $t("MESSAGES.settlementAmount") }}
                    <span class="text-danger">*</span>
                  </label>
                  <div class="adjust_balance_input_row">
                    <input
                      type="text"
                      inputmode="numeric"
                      maxlength="7"
                      class="adjust_balance_input"
                      v-model.trim="settlementAmount"
                      :disabled="isWaitingRequest"
                      @keypress="allowDigitsOnly"
                    />
                    <span class="adjust_balance_currency">{{
                      $t("PLACEHOLDERS.riyal")
                    }}</span>
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  class="modal_confirm_btn"
                  :disabled="isWaitingRequest"
                  @click="confirmAdjustBalance"
                >
                  {{ $t("BUTTONS.save") }}
                </v-btn>
                <v-btn
                  class="modal_cancel_btn"
                  :disabled="isWaitingRequest"
                  @click="closeAdjustBalanceModal"
                >
                  {{ $t("BUTTONS.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>


        </template>
        <!-- ======================== End:: Dialogs ======================== -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "AllAreas",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),

    activeStatuses() {
      return [
        {
          id: 1,
          name: this.$t("STATUS.active"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("STATUS.notActive"),
          value: 0,
        },
      ];
    },
  },

  data() {
    return {
      selected: [],
      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        name: null,
        status: null,
      },
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      categories: [],
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "id",
          align: "center",
          width: "80",
          sortable: false,
        },
        {
          text: this.$t("MESSAGES.sort"),
          value: "sort",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.provider_name"),
          value: "name",
          sortable: false,
          align: "center",
          width: "320",
        },
        {
          text: this.$t("PLACEHOLDERS.status"),
          value: "is_active",
          align: "center",
          sortable: false,
          width: "120",
        },
        {
          text: this.$t("MESSAGES.centerBalance"),
          value: "balance",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.add_at"),
          value: "created_at",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("TABLES.Admins.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Dialogs Control Data
      dialogDelete: false,
      itemToDelete: null,
      dialogStats: false,
      itemToStats: null,
      dialogAdjustBalance: false,
      itemToAdjustBalance: null,
      centerBalance: 0,
      settlementAmount: null,
      // End:: Dialogs Control Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
      // End:: Pagination Data

      // Start:: Page Permissions
      permissions: null,
      // Start:: Page Permissions

      allMainProviders: [],
      shares_count: 0,
      favorites_count: 0,
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    exchangeOrders() {
      this.loading = true;
      const REQUEST_DATA = new FormData();
      if (this.selected){
        this.selected.map((item) => {
          REQUEST_DATA.append("ids[]", item);
        })
      }
      REQUEST_DATA.append("type", "festival_providers");
      try {
        let res = this.$axios({
          method: "POST",
          url: "swap-order",
          data: REQUEST_DATA,
        });
        this.$message.success(this.$t("MESSAGES.Exchanged successfully"));
        this.selected = [];
        this.setTableRows();
        this.loading = false;
      } catch (error) {
        this.loading = false;

      }
    },
    getRowClass(item) {
      return this.selected.includes(item.id) ? 'checked-box' : ''
    },
    handleChange() {
      if (this.selected.length >= 2) {
        // disable all unchecked
        this.$nextTick(() => {
          const checkboxes = this.$el.querySelectorAll('input[type="checkbox"]');
          checkboxes.forEach(cb => {
            cb.disabled = !this.selected.includes(Number(cb.value));
          });
        });
      } else {
        // re-enable all
        const checkboxes = this.$el.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(cb => (cb.disabled = false));
      }
    },
    incrementShare() {
      this.shares_count += 1;
    },
    decrementShare() {
      this.shares_count -= 1;
    },
    incrementFav() {
      this.favorites_count += 1;
    },
    decrementFav() {
      this.favorites_count -= 1;
    },
    // Start:: Handel Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/festival-providers/all",
          query: {page: 1},
        });
      }
      this.setTableRows();
    },
    async resetFilter() {
      this.filterOptions.name = null;
      this.filterOptions.status = null;
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/festival-providers/all",
          query: {page: 1},
        });
      }
      this.setTableRows();
    },
    // End:: Handel Filter

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Products
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "festival-providers",
          params: {
            page: this.paginations.current_page,
            name: this.filterOptions.name,
            is_active: this.filterOptions.status?.value,
          },
        });
        this.loading = false;
        // console.log("All Data ==>", res.data.data);
        this.tableRows = res.data.data.data;
        this.paginations.last_page = res.data.data.meta.last_page;
        this.paginations.items_per_page = res.data.data.meta.per_page;
        this.handleChange()
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows

    // ==================== Start:: Crud ====================
    // ===== Start:: Edit
    editItem(item) {
      this.$router.push({path: `/festival-providers/edit/${item.id}`});
    },
    showItem(item) {
      this.$router.push({path: `/festival-providers/show/${item.id}`});
    },
    socialItem(item) {
      this.$router.push({path: `/festival-providers/provider-social/${item.id}`});
    },
    timeItem(item) {
      this.$router.push({path: `/festival-providers/provider-hours/${item.id}`});
    },
    departItem(item) {
      this.$router.push({path: `/festival-providers/departments/${item.id}`});
    },

    allowDigitsOnly(event) {
      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
      }
    },

    resolveProviderBalance(provider) {
      return Number(provider?.balance ?? 0) || 0;
    },

    validateSettlementAmount() {
      const amountStr = String(this.settlementAmount ?? "").trim();

      if (!amountStr) {
        return this.$t("VALIDATION.settlementAmountRequired");
      }

      if (!/^\d{1,7}$/.test(amountStr)) {
        return this.$t("VALIDATION.settlementAmountInvalid");
      }

      const amount = Number(amountStr);
      if (amount < 1) {
        return this.$t("VALIDATION.settlementAmountMin");
      }

      if (amount > this.centerBalance) {
        return this.$t("VALIDATION.settlementAmountExceedsBalance");
      }

      return null;
    },

    async openAdjustBalanceModal(item) {
      this.itemToAdjustBalance = item;
      this.settlementAmount = null;
      this.centerBalance = this.resolveProviderBalance(item);
      this.dialogAdjustBalance = true;

      try {
        const res = await this.$axios({
          method: "GET",
          url: `festival-providers/${item.id}`,
        });
        this.centerBalance = this.resolveProviderBalance(
          res.data.data.FestivalProvider
        );
      } catch (error) {
        this.$message.error(error.response?.data?.message);
      }
    },

    closeAdjustBalanceModal() {
      this.dialogAdjustBalance = false;
      this.itemToAdjustBalance = null;
      this.settlementAmount = null;
      this.centerBalance = 0;
    },

    async confirmAdjustBalance() {
      const validationError = this.validateSettlementAmount();
      if (validationError) {
        this.$message.error(validationError);
        return;
      }

      if (!this.itemToAdjustBalance) return;

      this.isWaitingRequest = true;
      try {
        await this.$axios({
          method: "POST",
          url: `festival-providers/${this.itemToAdjustBalance.id}/adjust-balance`,
          data: {
            amount: Number(this.settlementAmount),
          },
        });
        this.closeAdjustBalanceModal();
        this.$message.success(this.$t("MESSAGES.balanceAdjustedSuccessfully"));
        await this.setTableRows();
      } catch (error) {
        this.$message.error(error.response?.data?.message);
      } finally {
        this.isWaitingRequest = false;
      }
    },
    // ===== End:: Edit

    // ===== Start:: Delete
    selectDeleteItem(item) {
      this.dialogDelete = true;
      this.itemToDelete = item;
    },
    selectStatsItem(item) {
      this.dialogStats = true;
      this.shares_count = item.shares_count;
      this.favorites_count = item.favorites_count;
      this.itemToStats = item;
    },
    async confirmDeleteItem() {
      try {
        await this.$axios({
          method: "DELETE",
          url: `festival-providers/${this.itemToDelete.id}`,
        });
        this.dialogDelete = false;
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
      } catch (error) {
        this.dialogDelete = false;
        this.$message.error(error.response.data.message);
      }
    },
    async confirmAddStats() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("shares_count", this.shares_count);
      REQUEST_DATA.append("favorites_count", this.favorites_count);
      try {
        await this.$axios({
          method: "POST",
          url: `festival-providers/statistics/${this.itemToStats.id}`,
          data: REQUEST_DATA
        });
        this.dialogStats = false;
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.statistics updated"));
      } catch (error) {
        this.dialogStats = false;
        this.$message.error(error.response.data.message);
      }
    },
    // ===== End:: Delete
    // ==================== End:: Crud ====================

    // Start:: Change Activation Status
    async changeActivationStatus(item) {
      const REQUEST_DATA = new FormData();
      // REQUEST_DATA.append("is_active", +item.status == 1 ? 0 : 1);
      try {
        let response = await this.$axios({
          method: "POST",
          url: `festival-providers/status/${item.id}`,
        });
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.changedSuccessfully"));
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
  },

  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }

    this.setTableRows();
    // End:: Fire Methods
  },
};
</script>
<style>
.checked-box {
  box-shadow: 13px 1px 9px 10px #d5d5d5 !important;
  transition: box-shadow 0.3s ease !important;
  border-radius: 8px !important;
}

.adjust_balance_provider_name {
  margin-bottom: 16px;
  text-align: center;
  color: var(--main_theme_clr);
  font-weight: 700;
}

.adjust_balance_field {
  margin-bottom: 18px;
}

.adjust_balance_field label {
  display: block;
  margin-bottom: 8px;
  color: var(--theme_text_clr);
  font-weight: 600;
}

.adjust_balance_value {
  margin: 0;
  padding: 12px 14px;
  border-radius: 10px;
  background: var(--secondary_theme_clr);
  color: var(--theme_text_clr);
  font-size: 1.05rem;
  font-weight: 700;
}

.adjust_balance_input_row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.adjust_balance_input {
  flex: 1;
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid var(--very_light_theme_clr);
  border-radius: 10px;
  background: var(--theme_inputs_clr);
  color: var(--theme_text_clr);
  direction: ltr;
  text-align: start;
}

.adjust_balance_currency {
  flex-shrink: 0;
  color: var(--theme_secondary_text_clr);
  font-weight: 600;
}

.ltr_text {
  direction: ltr;
  unicode-bidi: isolate;
  display: inline-block;
}
</style>
